export enum PlatformBillingInvoiceStateEnum {
    DRAFT = 'draft',
    ISSUED = 'issued',
    CANCELLED = 'cancelled',
    ERROR = 'error',
}
